import createModalStorage from './createModalStorage';
import {createElement} from '../dom-utils';
import {requestIdleCallback} from '../dom-utils/promises';
import getPlayback from '../libs/animation-playback';

/** @typedef {import('../libs/animation-playback').AnimationOptions} AnimationOptions */

/** @type {AnimationOptions} */
const fadeInClasses = {
    class: 'fade-in',
    activeClass: 'fade-in-active',
    toClass: 'fade-in-to',
}

/** @type {AnimationOptions} */
const fadeOutClasses = {
    class: 'fade-out',
    activeClass: 'fade-out-active',
    toClass: 'fade-out-to',
}

const getBackdrop = () => {
    const div = createElement('div');

    div.classList.add('backdrop');

    return div;
}

/**
 *
 * @param {HTMLElement} backdrop
 */
const show = async (backdrop) => {
    const animation = getPlayback(backdrop, fadeInClasses);

    backdrop.classList.remove(...Object.values(fadeOutClasses));
    document.body.appendChild(backdrop);

    await requestIdleCallback();

    animation.play();

    await animation.done;
}

/**
 *
 * @param {HTMLElement} backdrop
 */
const hide = async (backdrop) => {
    const animation = getPlayback(backdrop, fadeOutClasses);

    backdrop.classList.remove(...Object.values(fadeInClasses));
    animation.play();

    await animation.done;

    document.body.removeChild(backdrop);
}

export default async function createBackdrop() {
    const modals = createModalStorage();
    const backdrop = getBackdrop();

    modals.subscribe(async (count) => {
        if (count === 0 && backdrop.parentElement) {
            return await hide(backdrop);
        } else if (count > 0 && !backdrop.parentElement) {
            return await show(backdrop);
        }
    });
}
